import { GradooTheme } from 'gradoo-theme/lib/types'
import { ReactNode } from 'react'
import styled, { css } from 'styled-components'

import Text from 'shared/ui/Text'

const Container = styled.label<{ $disabled?: boolean }>`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  cursor: ${({ $disabled }) =>
    $disabled ? 'not-allowed' : 'pointer'};
  color: ${({ theme }) => theme.color.base.c10};
  user-select: none;
`

const HiddenCheckbox = styled.input.attrs({ type: 'checkbox' })`
  position: absolute;
  opacity: 0;
  pointer-events: none;
`

const Box = styled.span<{
  $checked: boolean
  $disabled?: boolean
}>`
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  border-radius: 6px;
  border: 1.5px solid ${({ theme }) => theme.color.base.c3};
  background: ${({ theme }) => theme.color.base.c0};
  transition: all 0.15s ease-in-out;

  ${({ $checked, theme }) =>
    $checked &&
    css`
      border-color: ${theme.color.brand_02};
      background: ${theme.color.brand_02};
      box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
    `}

  ${({ $disabled, theme }) =>
    $disabled &&
    css`
      border-color: ${theme.color.base.c3};
      background: ${theme.color.base.c2};
    `}

  &::after {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    width: 5px;
    height: 10px;
    border: 2px solid ${({ theme }) => theme.color.base.c0};
    border-top: 0;
    border-left: 0;
    transform: translate(-50%, -50%) rotate(45deg);
    opacity: ${({ $checked }) => ($checked ? 1 : 0)};
    transition: opacity 0.1s ease-in-out;
  }
`

type CheckboxProps = {
  checked: boolean
  onChange: (value: boolean) => void
  label?: ReactNode
  disabled?: boolean
  name?: string
  value?: string
  id?: string
  className?: string
}

const Checkbox: React.FC<CheckboxProps> = ({
  checked,
  onChange,
  label,
  disabled,
  name,
  value,
  id,
  className
}) => {
  return (
    <Container className={className} $disabled={disabled}>
      <HiddenCheckbox
        id={id}
        name={name}
        value={value}
        checked={checked}
        disabled={disabled}
        onChange={event => onChange(event.target.checked)}
      />
      <Box $checked={checked} $disabled={disabled} aria-hidden />
      {label ? (
        <Text
          tag="span"
          size={14}
          weight={600}
          text={label as string}
          color={(theme: GradooTheme) =>
            disabled ? theme.color.base.c4 : theme.color.base.c8
          }
        />
      ) : null}
    </Container>
  )
}

export default Checkbox
